module.exports = __webpack_public_path__ + "img/fitbit-dashboard.9cb56d8f.svg";